<!--
  ~ Copyright © 2025 Gavin Sawyer. All rights reserved.
  -->

<section class="harness">
  <div class="between"><ng-container *ngTemplateOutlet="contentTemplate" /></div>
</section>

<ng-template #badgeSymbolTemplate>
  @if (containerDirective.badgeSymbolTemplateRef$(); as badgeSymbolTemplateRef) {<div id="badgeSymbol">
    <ng-container *ngTemplateOutlet="badgeSymbolTemplateRef" />
  </div>}
</ng-template>
<ng-template #contentTemplate>
  <ng-content />
  <ng-container *ngTemplateOutlet="badgeSymbolTemplate" />
</ng-template>
